import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router';
var ReadAllArticles = function ReadAllArticles(_ref) {
  var title = _ref.title;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  if (!articleID) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "article__read-all"
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: pathname.replace(articleID, '').replace(/\/$/, '')
  }, "Read All ", title, " \xBB"));
};
export default ReadAllArticles;